export default "__VITE_ASSET__BMKhQbgN__"